module.exports = __webpack_public_path__ + "media/images/covers/sw-thumb-05-a636800cb610c80fc766a0eaaeee2b0a.jpg";